// colors.js
export default {
  primary: '#42A5F5',
  secondary: '#FF5722',
  background: '#FAFAFA',
  grayColor: '#69696D',
  darkColor: '#13161B',
  selectedColor: '#D3E3FD',
  hoverColor:'#EBEEF6',
  anatomicCrown:'#e56ae6',
  offsetInlay:'#17e0a5',
  missingTooth:'#56cad6',
  veneer:'#f06086',
  anatomicInlay:'#ff8837',
  anatomicPontic:'#498ef2',
};